/** X/Y axis lines only — no grid, no tick marks. */
export const MINIMAL_CHART_AXIS = {
  axisLine: { stroke: "#bdbdbd" },
  tickLine: false,
  tick: { fontSize: 11 },
} as const;
